export default __webpack_public_path__ + "static/media/Enterprise_consulting.b16ab4ff.png";